import { render, staticRenderFns } from "./batch-approval.vue?vue&type=template&id=0349bd4e&scoped=true&"
import script from "./batch-approval.vue?vue&type=script&lang=js&"
export * from "./batch-approval.vue?vue&type=script&lang=js&"
import style0 from "./batch-approval.vue?vue&type=style&index=0&id=0349bd4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349bd4e",
  null
  
)

export default component.exports